import React from 'react';
import { Alert } from '@mui/material';

interface SinSucursalesAsignadasAlertProps {
  esAdmin?: boolean;
  sx?: object;
}

const SinSucursalesAsignadasAlert: React.FC<SinSucursalesAsignadasAlertProps> = ({
  esAdmin = false,
  sx,
}) => {
  if (esAdmin) return null;

  return (
    <Alert severity="error" sx={{ mb: 2, borderRadius: 2, ...sx }}>
      No tiene sucursales de venta asignadas. Contacte al administrador.
    </Alert>
  );
};

export default SinSucursalesAsignadasAlert;
